import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import DataTypes from '../../../../../constants/dataTypes';
import { getDisplayValueForType } from '../../../../../utils/tableUtil';

const LatestEmailCell = ({ value: latestEmail }) => {
  if (!latestEmail?.createdAt) {
    return (
      <Box>Never Sent</Box>
    );
  }

  return <Box>{getDisplayValueForType(latestEmail.createdAt, DataTypes.DateTime)}</Box>;
};

LatestEmailCell.propTypes = { value: PropTypes.shape({ createdAt: PropTypes.string }) };

export default LatestEmailCell;
